import { PALETTE, SIZES, MQ_TABLET} from '../../../constants';
import { MediaQueryStyleSheet } from "react-native-responsive";
import ResponsiveDimensionValues from '../../../components/common/responsive-dimension-values';

const WINDOW_WIDTH = ResponsiveDimensionValues.windowWidth;
const blue = '#13223b';

export default MediaQueryStyleSheet.create({
  root: {
    flex: 1,
    paddingVertical: 10,
    paddingHorizontal: 10,
    backgroundColor: PALETTE.loginBg,
  },
  profilePadd: {
    marginBottom:10,
    padding:13,
    backgroundColor: blue,
  },
  labelText: {
    flex: 1,
  },
  row: {
    flex: 0,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  setBottom: {
    flex : 0,
    left:0,
    right:0,
    bottom: 10,
    backgroundColor: PALETTE.loginSecondary,
  },
  label: {
    color: PALETTE.secondaryText,
  },
  filter: {
    flex: 9,
  },
  bannerContainer: {
    width: '100%',
    marginTop: 4,
    marginBottom: 16,
  },
  activityLoader:{
    flex:1,
    justifyContent:'center',
    alignSelf:'center'
  },
  rootSearch: {
    flex: 9,
    marginLeft:100,
    marginRight:100,
  },
  searchIconStyle: {
    right: 15, 
    top: -38, 
    position: 'absolute'
  },
  searchBox: {
    height: 40,
    paddingHorizontal: 10,
    top: -45, 
    marginLeft: 35
  }
});

export const activeSVGStyles = {
  color: PALETTE.primaryText,
};

export const inactiveSVGStyles = {
  color: 'rgba(255, 255, 255, 0.4)', // TODO palettise
};
